import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Table(props) {
    const actionCellClass = props.actionCellClassName || "px-6 py-4 whitespace-nowrap text-right text-sm font-medium";

    function getValueFromPath(obj, path) {
        if (!path) return undefined;
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    }

    return (
        <div className={`flex flex-col`}>
            <div className={`-my-2 ${!props.nonScrolleable && 'overflow-x-auto'} sm:-mx-6 lg:-mx-8`}>
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className={`shadow ${!props.sticky && 'overflow-hidden'} border-b border-gray-200 dark:border-gray-600 sm:rounded-lg`}>
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className={`bg-gray-50 dark:bg-gray-600 ${props.sticky && 'sticky top-0 z-30 shadow-sm'}`}>
                                <tr>
                                    {props.columns.map((column, colIndx) => (
                                        <th
                                            key={column.name || colIndx}
                                            scope="col"
                                            className={`${props.sticky && colIndx === 0 && 'sticky left-0 bg-gray-50'} px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider`}
                                        >
                                            {column.displayText}
                                        </th>
                                    ))}
                                    {props.actiontext && <th scope="col" className="relative px-6 py-3">
                                        <span className="sr-only">Edit</span>
                                    </th>}
                                    {props.delete && <th scope="col" className="relative px-6 py-3">
                                        <span className="sr-only">Edit</span>
                                    </th>}
                                    {props.openModal && <th scope="col" className="relative px-6 py-3">
                                        <span className="sr-only">Edit</span>
                                    </th>}
                                </tr>
                            </thead>
                            <tbody>
                                {props.rows.map((row, rowIdx) => (
                                    <tr key={rowIdx} className={rowIdx % 2 === 0 ? 'bg-white dark:bg-gray-900' : 'bg-gray-100 dark:bg-gray-800'} onClick={() => props.navigate && props.navigate(`/${props.path}/${row.id}`)} style={{ cursor: props.navigate ? 'pointer' : 'default' }} >
                                        {row.isTitle && 
                                        <td key={`title-${row.id || rowIdx}`} className={`${props.sticky && (`${rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} sticky left-0 z-20`)} px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-800 dark:text-white`}>
                                            {row.name}
                                        </td>}
                                        {props.columns.map((column, colIdx) => (
                                            column.clickable ?
                                                <td key={`${row.id || rowIdx}-${column.name || colIdx}`} className={`${props.sticky && colIdx === 0 && (`${rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} sticky left-0 z-20`)} ${column.truncate ? 'truncate max-w-xs' : ''} px-6 py-4 whitespace-nowrap text-left text-sm font-medium`}>
                                                    <Link to={`/${props.module}/${row.id}`} className="text-primary hover:text-primary">
                                                        {getValueFromPath(row, column.name)}
                                                    </Link>
                                                </td>
                                                :
                                                (colIdx !== 0 || !row.isTitle) && 
                                                <td key={`${row.id || rowIdx}-${column.name || colIdx}`} className={`${props.sticky && colIdx === 0 && (`${rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} sticky left-0 z-20`)} ${column.truncate ? 'truncate max-w-xs' : ''} px-6 py-4 whitespace-nowrap text-gray-500 dark:text-gray-200  text-sm  ${!!props.firstColumnBold && colIdx === 0 && 'font-normal'}`} title={((getValueFromPath(row, column.name) || getValueFromPath(row, column.name) === 0) ? getValueFromPath(row, column.name) : '')} > 
                                                    {!row.isTitle && ((getValueFromPath(row, column.name) || getValueFromPath(row, column.name) === 0) ? getValueFromPath(row, column.name) : '--')}
                                                </td>
                                        ))}
                                        {props.actiontext && <td className={actionCellClass}>
                                            {props.document ?
                                                <a target="_BLANK" rel="noopener noreferrer" href={row.document} className="text-primary hover:text-primary">
                                                    {props.actiontext}
                                                </a>
                                                :
                                                <Link to={`/${props.module}/${row.id}`} className="text-primary hover:text-primary">
                                                    {props.actiontext}
                                                </Link>
                                            }

                                        </td>}
                                        {props.delete && <td className={actionCellClass}>
                                            <button onClick={() => (props.setSelectedDocument(row), props.setOpenDelete(true))} className="text-red hover:text-red">
                                                Eliminar
                                            </button>
                                        </td>}
                                        {props.openModal && <td className={actionCellClass}>
                                            <button onClick={(e) => {
                                                e.stopPropagation();
                                                props.openModal(row);
                                                }} 
                                                className="text-primary hover:text-primary"
                                            >
                                                {props.openModalText || "Editar"}
                                            </button>
                                        </td>}
                                    </tr>
                                ))}
                            </tbody>
                            {props.pages ? <tfoot>
                                <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 dark:border-gray-600 sm:px-6">
                                    <div className="flex-1 flex justify-between sm:hidden">
                                        <a
                                            href="#"
                                            className="relative inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600  text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                                        >
                                            Previous
                                        </a>
                                        <a
                                            href="#"
                                            className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600  text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                                        >
                                            Next
                                        </a>
                                    </div>
                                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                                        <div>
                                            <p className="text-sm text-gray-700">
                                                Mostrando <span className="font-medium">{props.start}</span> to <span className="font-medium">{props.end}</span> of{' '}
                                                <span className="font-medium">{props.total}</span> resultados
                                            </p>
                                        </div>
                                        <div>
                                            <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                                                <a
                                                    href="#"
                                                    className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                                                >
                                                    <span className="sr-only">Previous</span>
                                                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                                                </a>
                                                {/* Current: "z-10 bg-indigo-50 border-primary text-primary", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}
                                                {props.pages?.map((element) => {
                                                    return (
                                                        <button
                                                            key={element.number}
                                                            type="button"
                                                            aria-current={element.current}
                                                            className={element.current ?
                                                                "z-10 bg-indigo-50 border-primary text-primary relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                                                                : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                                                            }
                                                        >
                                                            {element.number}
                                                        </button>
                                                    )
                                                })}
                                                <a
                                                    href="#"
                                                    className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                                                >
                                                    <span className="sr-only">Next</span>
                                                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                                                </a>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </tfoot>
                                : null}
                        </table>
                    </div>
                </div>
            </div>
        </div >
    )

}

export const PageControler = ({start, end, total, page, totalPages, setPage, previous, next}) => {
    return (
        <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="text-sm text-gray-600 dark:text-gray-400 text-center sm:text-left">
                Mostrando <span className="font-medium">{start}</span> a{" "}
                <span className="font-medium">{end}</span> de{" "}
                <span className="font-medium">{total}</span>
            </div>

            <div className="flex items-center justify-center gap-2">
                <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm font-semibold text-gray-700 dark:text-gray-200 shadow-sm transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed"
                    disabled={!previous}
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                >
                    <ChevronLeftIcon className="h-4 w-4" />
                    <span className="hidden sm:inline">Anterior</span>
                </button>

                <div className="px-3 py-2 text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">
                    <span className="font-medium">{page}</span>
                    <span className="mx-1">/</span>
                    <span className="font-medium">{totalPages}</span>
                </div>

                <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm font-semibold text-gray-700 dark:text-gray-200 shadow-sm transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed"
                    disabled={!next}
                    onClick={() => setPage((p) => p + 1)}
                >
                    <span className="hidden sm:inline">Siguiente</span>
                    <ChevronRightIcon className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
};